import { Component, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';

import { IDashBoardAdminChartDetails } from '../dasboard-admin-chart-details.model';
import { ChartValue } from '../chart/chart-value.model';
import { PieChartOptions } from "../chart/pie-chart-options.model";

@Component({
    moduleId: module.id,
    selector: 'traffic',
    templateUrl: 'traffic.component.html'
})
export class TrafficComponent implements OnInit, OnChanges {
    @Input() data: IDashBoardAdminChartDetails;
    @Input() dataForToday: IDashBoardAdminChartDetails;
    @Input() showBottomSectionOverlay: boolean;
    ageGenderChartValues: ChartValue[];
    ageGenderChartOptions: PieChartOptions;
    deviceChartValues: ChartValue[];
    deviceChartOptions: PieChartOptions;
    triggerChange: Date;

    ngOnInit(){
        this.ageGenderChartOptions = new PieChartOptions();
        this.ageGenderChartOptions.legendSelector = "#donut_traffic_outside_legend";
        this.ageGenderChartOptions.height = 230;
        this.ageGenderChartOptions.series.pie.label.show = true;
        this.ageGenderChartOptions.series.pie.innerRadius = .53;
        this.ageGenderChartOptions.tooltip = true;

        this.deviceChartOptions = new PieChartOptions();
        this.deviceChartOptions.legendSelector = "#donut_traffic_inside_legend";
        this.deviceChartOptions.height = 230;
        this.deviceChartOptions.series.pie.label.show = true;
        this.deviceChartOptions.series.pie.innerRadius = .53;
        this.deviceChartOptions.tooltip = true;
    }

    private mapAllData(): void {
        this.ageGenderChartValues = new Array<ChartValue>();
        this.ageGenderChartValues.push(new ChartValue("Age & Gender", [this.data.traffic.hasAgeAndGender]));
        this.ageGenderChartValues.push(new ChartValue("Age", [this.data.traffic.hasAge]));
        this.ageGenderChartValues.push(new ChartValue("Gender", [this.data.traffic.hasGender]));
        this.ageGenderChartValues.push(new ChartValue("No Data", [this.data.traffic.noAgeOrGender]));

        this.deviceChartValues = new Array<ChartValue>();
        this.deviceChartValues.push(new ChartValue("Device - iOS", [this.data.traffic.hasDeviceIdIos]));
        this.deviceChartValues.push(new ChartValue("Device - Other", [this.data.traffic.hasDeviceIdOther]));
        this.deviceChartValues.push(new ChartValue("Device - Android", [this.data.traffic.hasDeviceIdAndroid]));
        this.deviceChartValues.push(new ChartValue("No Device - Android", [this.data.traffic.noDeviceIdAndroid]));
        this.deviceChartValues.push(new ChartValue("No Device - Other", [this.data.traffic.noDeviceIdOther]));
        this.deviceChartValues.push(new ChartValue("No Device - iOS", [this.data.traffic.noDeviceIdIos]));

        // Case from prod - 2 slices are 0% or close to 0%
        // this.deviceChartValues.push(new ChartValue("Device - iOS", [140175]));
        // this.deviceChartValues.push(new ChartValue("Device - Other", [0]));
        // this.deviceChartValues.push(new ChartValue("Device - Android", [1099707]));
        // this.deviceChartValues.push(new ChartValue("No Device - Android", [102727]));
        // this.deviceChartValues.push(new ChartValue("No Device - Other", [0]));
        // this.deviceChartValues.push(new ChartValue("No Device - iOS", [228507]));

        // Ideal Case:
        // this.deviceChartValues.push(new ChartValue("Device - Android", [20]));
        // this.deviceChartValues.push(new ChartValue("Device - iOS", [20]));
        // this.deviceChartValues.push(new ChartValue("Device - Other", [20])); 
        // this.deviceChartValues.push(new ChartValue("No Device - Android", [15])); 
        // this.deviceChartValues.push(new ChartValue("No Device - iOS", [15]));
        // this.deviceChartValues.push(new ChartValue("No Device - Other", [10]));

        // Edge Case 1 - narrow slices Top and LeftBottom:
        // this.deviceChartValues.push(new ChartValue("Device - Android", [5]));
        // this.deviceChartValues.push(new ChartValue("Device - iOS", [57]));
        // this.deviceChartValues.push(new ChartValue("No Device - Android", [3])); 
        // this.deviceChartValues.push(new ChartValue("No Device - iOS", [35]));

        // Edge Case 2 - narrow slices Top and Top:
        // this.deviceChartValues.push(new ChartValue("Device - Android", [5]));
        // this.deviceChartValues.push(new ChartValue("Device - iOS", [6]));
        // this.deviceChartValues.push(new ChartValue("No Device - Android", [44])); 
        // this.deviceChartValues.push(new ChartValue("No Device - iOS", [40]));

        // Edge Case 3 - narrow slices Top and Right:
        // this.deviceChartValues.push(new ChartValue("Device - Android", [5]));
        // this.deviceChartValues.push(new ChartValue("Device - iOS", [13]));
        // this.deviceChartValues.push(new ChartValue("No Device - Android", [3])); 
        // this.deviceChartValues.push(new ChartValue("No Device - iOS", [79]));

        // Edge Case 4 - narrow slices RightBottom and RightBottom:
        // this.deviceChartValues.push(new ChartValue("Device - Android", [43]));
        // this.deviceChartValues.push(new ChartValue("Device - iOS", [5]));
        // this.deviceChartValues.push(new ChartValue("No Device - Android", [3])); 
        // this.deviceChartValues.push(new ChartValue("No Device - iOS", [77]));
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.data && changes["data"] && changes["data"].previousValue != changes["data"].currentValue) {
            this.mapAllData();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/traffic/traffic.component.ts